<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert')">Carl Von
                        Schubert
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/egon-muller')">Egon Müller
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/jj-prum')">J.J. Prüm
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/peter-lauer')">Peter Lauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/van-volxem')">Van Volxem
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken')">
                        Weingut Forstmeister Geltz Zilliken
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch')">Wwe. Dr. H.
                        Thanisch, Erben Thanisch
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">J.J. Prüm</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Più comunemente noto ai collezionisti di vino investibili di tutto il mondo semplicemente come "J.J.", Weingut Joh.
                        Il soprannome di Jos. Prüm riflette la genialità del suo vino. Il produttore della Mosella è così altamente
                        considerato infatti, che il suo Wehlener Sonnenuhr Riesling supererà regolarmente il più alto del mondo
                        costose liste di vini. Ciò che rende questo particolarmente interessante è che, mentre le maree si girano verso
                        vini secchi e moderni, il Riesling bianco dolce di JJ lo mantiene tradizionale.
                    </div>

                    <div class="howto-title2">La terra santa</div>
                    <div class="howto-text">
                        Situato nel cuore della valle del fiume Mosella, le fortune di J.J. sono iniziate con il collocamento del suo
                        territorio. Probabilmente la regione vinicola più famosa e probabilmente più ammirata della Germania, la
                        valle è accanto al prestigioso Saar da un lato e Ruwer dall'altro. Tuttavia, il primo
                        spot appartiene al centro della valle - o la Mosella centrale (mittelmosel). E J.J
                        i vigneti sono proprio nell'occhio del ciclone.
                        <br><br>
                        I registri della famiglia Prum mostrano che la famiglia ha radici che risalgono al 1156 nella regione,
                        ma non divennero viticoltori fino al 1911, quando Johann Josef Prüm fondò la sua omonima tenuta a
                        1911. Oggi la tenuta di 16 ettari è gestita dal nipote e dalla pronipote di J.J.,
                        Manfred e Katharina (che, tra l'altro, sono entrambi avvocati e sono stati portati in cantina “a
                        dare una mano per l'estate”). Contrariamente a molte generazioni più giovani che gestiscono le cantine di famiglia,
                        Katharina non ha intenzione di apportare grandi cambiamenti alla tradizionale vinificazione della sua famiglia
                        metodi. Fondamentalmente, se non è rotto, non lo sta aggiustando.

                    </div>

                    <div class="howto-title2">Morbido, forte e molto lungo</div>
                    <div class="howto-text">
                        Il segreto di J.J. Il successo di Prüm risiede senza dubbio nella longevità dei suoi Riesling, una rarità
                        per i vini bianchi. Anche il Riesling Kabinett entry level manterrà fino a dieci anni se
                        in cantina correttamente, mentre i molti migliori vini delle annate più vecchie risalgono al
                        Gli anni '30 sono ancora bevibili (anche se estremamente difficili da trovare). È questo tre magico:
                        longevità, rarità e qualità che hanno reso il vigneto molto, molto costoso. Anche se suo
                        Wehlener Sonnenuhr Riesling Trokenbeerenauslese è sceso di 10 posizioni (dal 6° al 16°) in cinque
                        anni sui 50 vini più costosi del mondo, è ancora valutato a quasi € 5.000 a bottiglia in
                        Germania, a volte recuperando fino al doppio negli Stati Uniti.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Tre dei vini di J. J. Prüm fanno parte della lista dei vini tedeschi più costosi del 2019 (secondo wine-searcher.com); Wehlener Sonnenuhr Riesling Trockenbeerenauslese, Graacher Himmelreich Riesling Trockenbeerenauslese e Wehlener Sonnenuhr Riesling Beerenauslese.
                            </li>
                            <li>Un lotto di nove bottiglie di Wehlener Sonnenuhr Riesling Auslese Gold Capsule del 1990 venduto per
                                quasi 2.900 € all'asta/Sotheby's NY all'inizio di maggio 2019, 170-248% in più rispetto ai 1.164 € a
                                Stima € 1.701.
                            </li>
                            <li>Per gli investitori che cercano più valore di quello offerto dai vini più costosi di J. J., 2015
                                Wehlener Sonnenuhr Riesling Auslese con prezzi in media inferiori a € 50 a bottiglia nel secondo trimestre
                                2019, combinato con la sua finestra di bevute dal 2025 al 2040, e punteggi favorevoli come
                                18,5/20 di Jancis Robinson, questo vino offre davvero valore, soprattutto considerando
                                annate come quella del 2009 (con lo stesso punteggio aggregato di 93) sono aumentate del +30% nel 2018
                                solo.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">J.J. Prüm</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Unter investitionsfähigen Weinsammlern auf der ganzen Welt am häufigsten als „J.J.“ bekannt, ist Weingut Joh.
                        Der Spitzname von Jos. Prüm spiegelt die Genialität seines Weins wider. Der Moselerzeuger ist so hoch
                        Man geht davon aus, dass sein Wehlener Sonnenuhr Riesling regelmäßig die Spitzenreiter der Welt sein wird
                        teure Weinkarten. Was dies besonders interessant macht, ist die Tatsache, dass sich die Gezeiten ändern
                        Trockene, moderne Weine, der süße weiße Riesling von J.J. bleibt traditionell.
                    </div>

                    <div class="howto-title2">Das Heilige Land</div>
                    <div class="howto-text">
                        Im Herzen des Moseltals gelegen, begann J.J.s Schicksal mit der Unterbringung seines eigenen Hauses
                        Terroir. Die wohl bekannteste und wohl am meisten bewunderte Weinregion Deutschlands
                        Das Tal grenzt auf der einen Seite an die prestigeträchtige Saar und auf der anderen an die Ruwer. Allerdings die Primzahl
                        Der Ort gehört zur Mitte des Tals – oder zur Mittelmosel. Und J.J.’s
                        Weinberge liegen direkt im Auge des Sturms.
                        <br><br>
                        Aus Aufzeichnungen der Familie Prüm geht hervor, dass die Wurzeln der Familie in der Region bis ins Jahr 1156 zurückreichen.
                        wurden aber erst 1911 Winzer, als Johann Josef Prüm sein gleichnamiges Weingut gründete
                        1911. Heute wird das 16 Hektar große Anwesen von J.J.s Enkel und Urenkelin geführt.
                        Manfred und Katharina (die übrigens beide Rechtsanwälte sind und ins Weingut geholt wurden)
                        Hilfe für den Sommer“). Im Gegensatz zu vielen jüngeren Generationen, die die Weingüter ihrer Familie leiten,
                        Katharina hat nicht vor, den traditionellen Weinbau ihrer Familie grundlegend zu verändern
                        Methoden. Im Grunde gilt: Wenn es nicht kaputt ist, wird sie es auch nicht reparieren.

                    </div>

                    <div class="howto-title2">Weich, stark und sehr lang</div>
                    <div class="howto-text">
                        Das Geheimnis von J.J. Prüms Erfolg liegt zweifellos an der Langlebigkeit seiner Rieslinge, eine Seltenheit
                        für Weißweine. Sogar der Riesling Kabinett der Einstiegsklasse ist bis zu zehn Jahre haltbar, wenn
                        richtig gelagert, während die vielen Spitzenweine aus den älteren Jahrgängen bereits aus der Zeit stammen
                        1930er-Jahre sind immer noch trinkbar (obwohl es äußerst schwierig ist, sie zu finden). Es sind diese magischen Drei:
                        Langlebigkeit, Seltenheit und Qualität, die den Weinberg so sehr, sehr teuer gemacht haben. Obwohl seines
                        Wehlener Sonnenuhr Riesling Trokenbeerenauslese ist von fünf Plätzen um 10 Plätze (vom 6. auf den 16. Platz) zurückgefallen
                        Obwohl er auch Jahre später zu den 50 teuersten Weinen der Welt zählt, liegt sein Wert immer noch bei fast 5.000 Euro pro Flasche
                        Deutschland, in den USA teilweise bis zum Doppelten.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Drei Weine von J. J. Prüm stehen 2019 auf der Liste der teuersten deutschen Weine (laut wine-searcher.com); Wehlener Sonnenuhr Riesling Trockenbeerenauslese, Graacher Himmelreich Riesling Trockenbeerenauslese und Wehlener Sonnenuhr Riesling Beerenauslese.
                            </li>
                            <li>Ein Neun-Flaschen-Lot Wehlener Sonnenuhr Riesling Auslese Gold Capsule aus dem Jahr 1990 wurde für verkauft
                                knapp 2.900 € bei Auktion/Sotheby’s NY Anfang Mai 2019, 170-248 % über den 1.164 €
                                Schätzung: 1.701 €.
                            </li>
                            <li>Für Anleger, die mehr Wert suchen, als die teuersten Weine von J. J. 2015 bieten
                                Wehlener Sonnenuhr Riesling Auslese mit durchschnittlichen Preisen von weniger als 50 € pro Flasche im zweiten Quartal
                                2019, kombiniert mit seinem Trinkfenster von 2025 bis 2040 und günstigen Ergebnissen wie
                                Mit 18,5/20 von Jancis Robinson bietet dieser Wein tatsächlich ein gutes Preis-Leistungs-Verhältnis – vor allem, wenn man bedenkt
                                Jahrgänge wie 2009 (mit der gleichen Gesamtpunktzahl von 93) stiegen 2018 um +30 %
                                allein.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">J.J. Prüm</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Le plus souvent connu des collectionneurs de vin investissables du monde entier sous le simple nom de "J.J.", Weingut Joh.
                        Le surnom de Jos. Prüm reflète la gentillesse de son vin. Le producteur de Moselle est si fortement
                        considéré en fait, que son Wehlener Sonnenuhr Riesling sera régulièrement en tête des plus grands
                        cartes de vins chères. Ce qui rend cela particulièrement intéressant, c'est que, alors que les marées tournent vers
                        vins secs et modernes, le riesling blanc doux de J.J. reste traditionnel.
                    </div>

                    <div class="howto-title2">La terre sainte</div>
                    <div class="howto-text">
                        Situé au cœur de la vallée de la Moselle, la fortune de J.J. a commencé avec le placement de son
                        terroir. Probablement la région viticole la plus célèbre et sans doute la plus admirée d'Allemagne, la
                        La vallée jouxte la prestigieuse Sarre d'un côté et la Ruwer de l'autre. Cependant, le premier
                        place appartient au centre de la vallée - ou la Moselle moyenne (mittelmosel). Et J.J.
                        les vignobles sont en plein dans l'œil du cyclone.
                        <br><br>
                        Les archives de la famille Prum montrent que la famille a des racines remontant à 1156 dans la région,
                        mais ne deviendra vigneron qu'en 1911, lorsque Johann Josef Prüm fonde son domaine éponyme à
                        1911. Aujourd'hui, le domaine de 16 hectares est géré par l'équipe du petit-fils et de l'arrière-petite-fille de J.J.,
                        Manfred et Katharina (qui, soit dit en passant, sont tous deux avocats et ont été amenés dans la cave « pour
                        aide pour l'été »). Contrairement à de nombreuses jeunes générations qui exploitent les domaines viticoles de leur famille,
                        Katharina ne prévoit pas d'apporter des changements majeurs à la vinification traditionnelle de sa famille
                        méthodes. En gros, si ce n'est pas cassé, elle ne le répare pas.

                    </div>

                    <div class="howto-title2">Doux, fort et très long</div>
                    <div class="howto-text">
                        Le secret de J.J. Le succès de Prüm réside sans aucun doute dans la longévité de ses Rieslings, une rareté
                        pour les vins blancs. Même le Riesling Kabinett d'entrée de gamme se conservera jusqu'à dix ans s'il
                        correctement mis en cave, tandis que les nombreux grands vins des millésimes plus anciens d'aussi loin que le
                        Les années 1930 sont encore potables (bien qu'extrêmement difficiles à trouver). C'est ce trois magique :
                        longévité, rareté et qualité qui ont rendu le vignoble si cher, très cher. Bien que son
                        Wehlener Sonnenuhr Riesling Trokenbeerenauslese a perdu 10 places (de la 6e à la 16e) en cinq
                        ans sur les 50 vins les plus chers du monde, il est toujours valorisé à près de 5 000 € la bouteille en
                        L'Allemagne, qui rapporte parfois jusqu'à deux fois plus aux États-Unis.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Trois des vins de J.J. Prüm figurent sur la liste 2019 des vins allemands les plus chers (selon wine-searcher.com); Wehlener Sonnenuhr Riesling Trockenbeerenauslese, Graacher Himmelreich Riesling Trockenbeerenauslese et Wehlener Sonnenuhr Riesling Beerenauslese.
                            </li>
                            <li>Un lot de neuf bouteilles de 1990 Wehlener Sonnenuhr Riesling Auslese Gold Capsule vendu pour
                                près de 2 900 € aux enchères/Sotheby's NY début mai 2019, 170-248 % au-dessus des 1 164 € à
                                Estimation 1 701 €.
                            </li>
                            <li>Pour les investisseurs à la recherche d'une valeur supérieure à celle offerte par les vins les plus chers de J.J., 2015
                                Wehlener Sonnenuhr Riesling Auslese avec des prix moyens inférieurs à 50 € la bouteille au T2
                                2019, combiné avec sa fenêtre de consommation de 2025 à 2040, et des scores favorables tels que
                                18,5/20 de Jancis Robinson, ce vin offre vraiment de la valeur - surtout si l'on considère
                                des millésimes comme celui de 2009 (avec la même note agrégée de 93) ont bondi de +30% en 2018
                                seul.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">J.J. Prüm</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Most commonly known to investable wine collectors the world over as simply “J.J.”, Weingut Joh.
                        Jos. Prüm’s nickname reflects the geniality of his wine. The Mosel producer is so highly
                        regarded in fact, that his Wehlener Sonnenuhr Riesling will regularly top the world’s most
                        expensive wines lists. What makes this particularly interesting is that, as tides turn towards
                        dry, modern wines, J.J.’s sweet white Riesling keeps it traditional.
                    </div>

                    <div class="howto-title2">The holy land</div>
                    <div class="howto-text">
                        Set in the heart of the Mosel River Valley, J.J.’s fortunes began with the placement of his
                        terroir. Probably the most famous and arguably the most admired wine region of Germany, the
                        valley is next to the prestigious Saar to one side and Ruwer to the other. However, the prime
                        spot belongs to the centre of the valley - or the middle Mosel (mittelmosel). And J.J.’s
                        vineyards are right in the eye of the storm.
                        <br><br>
                        Prum family records show that the family have roots dating as far back as 1156 in the region,
                        but did not become winemakers until 1911, when Johann Josef Prüm founded his eponymous estate in
                        1911. Today the 16-hectare estate is run by J.J.’s grandson and great-granddaughter team,
                        Manfred and Katharina (who, by the way, are both lawyers and were brought into the winery “to
                        help out for the summer”). Contrary to many younger generations who run their family’s wineries,
                        Katharina is not planning on making major changes to her family’s traditional winemaking
                        methods. Basically, if it ‘ain’t broke, she ‘aint fixing it.

                    </div>

                    <div class="howto-title2">Soft, strong and very long</div>
                    <div class="howto-text">
                        The secret to J.J. Prüm’s success lies undoubtedly in the longevity of his Rieslings, a rarity
                        for white wines. Even the entry level Riesling Kabinett will keep for up to ten years if
                        cellared correctly, while the many top wines from the older vintages from as far back as the
                        1930s are still drinkable (although extremely difficult to find). It is this magic three:
                        longevity, rarity and quality that has made the vineyard so very, very expensive. Although his
                        Wehlener Sonnenuhr Riesling Trokenbeerenauslese has fallen 10 places (from 6th to 16th) in five
                        years on the world’s 50 most expensive wines, it is still valued at almost €5,000 a bottle in
                        Germany, sometimes fetching up to twice that much in the US.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>Three of J. J. Prüm’s wines make 2019’s list of most expensive German wines (according to wine-searcher.com); Wehlener Sonnenuhr Riesling Trockenbeerenauslese, Graacher Himmelreich Riesling Trockenbeerenauslese, and Wehlener Sonnenuhr Riesling Beerenauslese.
                            </li>
                            <li>A nine bottle lot of 1990 Wehlener Sonnenuhr Riesling Auslese Gold Capsule sold for
                                nearly €2,900 at auction/Sotheby’s NY in early May 2019, 170-248% above the €1,164 to
                                €1,701 estimate.
                            </li>
                            <li>For investors looking for more value than offered by J. J.’s most expensive wines, 2015
                                Wehlener Sonnenuhr Riesling Auslese with prices averaging less than €50 per bottle in Q2
                                2019, combined with its 2025 to 2040 drinking window, and favourable scores such as
                                18.5/20 from Jancis Robinson, this wine offers value indeed - especially considering
                                vintages such as 2009’s (with the same aggregated score of 93) jumped +30% in 2018
                                alone.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "JjPrum",
    data() {
        return {
            select: {report: 'J.J. Prüm', src: '/wine-guide/germany/mosel-saar-ruwer/jj-prum'},
            items: [
                {report: 'Carl Von Schubert', src: '/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert'},
                {report: 'Egon Müller', src: '/wine-guide/germany/mosel-saar-ruwer/egon-muller'},
                {report: 'J.J. Prüm', src: '/wine-guide/germany/mosel-saar-ruwer/jj-prum'},
                {report: 'Peter Lauer', src: '/wine-guide/germany/mosel-saar-ruwer/peter-lauer'},
                {report: 'Van Volxem', src: '/wine-guide/germany/mosel-saar-ruwer/van-volxem'},
                {
                    report: 'Weingut Forstmeister Geltz Zilliken',
                    src: '/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken'
                },
                {
                    report: 'Wwe. Dr. H. Thanisch, Erben Thanisch',
                    src: '/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'J.J. Prüm | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality of J.J. Prüm, a leading wine producer in the Mosel region. With a long history of producing some of the finest Rieslings in the world, J.J. Prüm is a must-try for wine lovers. Experience the unique taste and complexity of these classic German wines.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
